<template lang="pug">
    .document-layout
        .document-layout__logo
            img(src="/images/client/got-me-hookd/logo.png" alt="GotMeHookd Logo")
        slot
</template>

<script>
export default {
    name: 'document-layout',
}
</script>
